import { CustomEditor } from '../../../global';
import { Editor } from 'slate';

export const unwrapLink = (editor: CustomEditor) => {
  Editor.removeMark(editor, 'link');
};
